import { CabecalhoDePagina, EsqueletoDeCartao } from "@base/ui";
import { CircleDashed } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Pagina de um modulo que ainda nao foi construido. Em vez de dado falso, diz o
 * que vai aparecer ali: serve de mapa do produto para quem usa e de lista de
 * requisitos para quem vai construir.
 */
export function PaginaPlanejada({
  rotulo,
  titulo,
  descricao,
  previsto,
  comEsqueleto = false,
}: {
  readonly rotulo?: ReactNode;
  readonly titulo: string;
  readonly descricao: ReactNode;
  /** O que a pagina vai mostrar quando o modulo existir. */
  readonly previsto: readonly string[];
  /** Mostra cartoes em carregamento no lugar dos paineis (para o Dashboard). */
  readonly comEsqueleto?: boolean;
}) {
  return (
    <div className="flex flex-col gap-secao">
      <CabecalhoDePagina rotulo={rotulo} titulo={titulo} descricao={descricao} />

      {comEsqueleto ? (
        <div className="grid auto-rows-min gap-bloco md:grid-cols-3">
          <EsqueletoDeCartao rotulo="Painel em construção" />
          <EsqueletoDeCartao rotulo="Painel em construção" />
          <EsqueletoDeCartao rotulo="Painel em construção" />
        </div>
      ) : null}

      <section
        aria-labelledby="previsto"
        className="flex max-w-3xl flex-col gap-bloco rounded-3xl border border-dashed bg-card/60 p-8"
      >
        <div className="flex flex-col gap-texto">
          <p className="text-xs font-semibold tracking-[0.12em] text-muted-foreground uppercase">
            Em construção
          </p>
          <h2 id="previsto" className="text-xl font-normal tracking-tight">
            O que vai aparecer aqui
          </h2>
        </div>
        <ul className="flex flex-col gap-4">
          {previsto.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
              <CircleDashed className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
